<template>
  <div style="display: flex; margin: 30px; flex-direction: column">
    <div
      style="
        margin: 10px;
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      "
    >
      <div>
        <h1 style="font-size: 20px">{{ $t("_liste_des_installations_") }}</h1>
      </div>
      <div style="display: flex; gap: 20px">
        <div>
          <v-btn
            @click="toggleButton('btnperformance')"
            :color="activeButton === 1 ? 'orange' : undefined"
          >
            {{ $t("_performance_") }}
          </v-btn>
        </div>
        <div>
          <v-btn
            @click="toggleButton('btnincident')"
            :color="activeButton === 2 ? 'orange' : undefined"
          >
            {{ $t("_incidents_") }}
          </v-btn>
        </div>
        <div>
          <v-btn
            @click="toggleButton('btnconformite')"
            :color="activeButton === 3 ? 'orange' : undefined"
          >
            {{ $t("_conformite_") }}
          </v-btn>
        </div>
      </div>
    </div>
    <div>
      <v-data-table
        :headers="takeheader()"
        :items="liste_fleet"
        class="custom-data-table"
        :footer-props="{
          'items-per-page-options': [20, 50, 100, -1],
          'items-per-page-text': this.$t('_lignes_par_page_'),
        }"
        style="width: 100%"
      >
        <template v-slot:body="{ items }">
          <tbody>
            <tr
              v-for="item in items"
              :key="item.id"
              :class="{ disabled: item.is_forbidden }"
            >
              <td
                v-for="column in takeheader()"
                :key="column.value"
                :style="{ cursor: 'pointer' }"
                @click="goToInstallation(item)"
              >
                {{ item[column.value] }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </div>
    <!-- <v-btn style="margin: 10px; margin-left: -20px; width: 300px;">{{ $t("_telecharger_le_tableau_comparatif_") }}</v-btn>-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    selectsite: {
      type: Array,
      required: true,
    },
    liste_fleet: { type: Array, default: () => [] },
    selected_date: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      btnperformance:
        JSON.parse(localStorage.getItem("btnperformance")) || false,
      btnincident: JSON.parse(localStorage.getItem("btnincident")) || false,
      btnconformite: JSON.parse(localStorage.getItem("btnconformite")) || false,
      chooseheader: [],
      start_date: "",
      end_date: "",
      activeButton: 0,
    };
  },
  mounted() {
    this.toggleButton("btnperformance");
  },
  watch: {
    "$root.$i18n.locale": {
      async handler() {
        await this.refresh_header_values();
        await this.takeheader();
        await this.toggleButton("btnperformance");
      },
      immediate: true,
    },
    $route: {
      async handler() {
        await this.refresh_header_values();
        await this.takeheader();
        await this.toggleButton("btnperformance");
      },
      immediate: true,
    },
    selected_date: {
      async handler() {
        await this.refresh_header_values();
        await this.takeheader();
        await this.toggleButton("btnperformance");
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(["role", "cur_install_id", "constants", "installations"]),
  },

  methods: {
    refresh_header_values() {
      this.chooseheader = [
        { text: this.$t("_site_"), value: "installation_name" },
        { text: this.$t("_puissance_crete_(kwc)_"), value: "pc_totale" },
        { text: this.$t("_adresse_"), value: "city", value_two: "country" },
        {
          text: this.$t("_company_name_"),
          value: "company_name",
        },
        {
          text: this.$t("_groupe_"),
          value: "groupe",
        },
        {
          text: this.$t("_type_d_installation_inclinaison_orientation_"),
          value: "installation_type",
        },
        { text: this.$t("_mise_en_service_"), value: "start_date" },
        { text: this.$t("_productible_"), value: "productible" },
        {
          text: this.$t("_actualisation_audit_performance_"),
          value: "audit_performance",
        },
      ];
    },
    toggleButton(button) {
      if (button === "btnperformance") {
        this.btnperformance = true;
        this.btnincident = false;
        this.btnconformite = false;
        this.activeButton = 1;
      } else if (button === "btnincident") {
        this.btnperformance = false;
        this.btnincident = true;
        this.btnconformite = false;
        this.activeButton = 2;
      } else if (button === "btnconformite") {
        this.btnperformance = false;
        this.btnincident = false;
        this.btnconformite = true;
        this.activeButton = 3;
      }

      localStorage.setItem(
        "btnperformance",
        JSON.stringify(this.btnperformance)
      );
      localStorage.setItem("btnincident", JSON.stringify(this.btnincident));
      localStorage.setItem("btnconformite", JSON.stringify(this.btnconformite));
    },

    isButtonDisabled(button) {
      if (button === "btnperformance") {
        return this.btnincident || this.btnconformite;
      } else if (button === "btnincident") {
        return this.btnperformance || this.btnconformite;
      } else if (button === "btnconformite") {
        return this.btnperformance || this.btnincident;
      }
      return false;
    },

    takeheader() {
      let dynamicHeaders = [...this.chooseheader];

      if (
        this.btnperformance &&
        !dynamicHeaders.some((header) => header.text === "performance")
      ) {
        dynamicHeaders.push({
          text: this.$t("_statut_de_performance_"),
          value: "statut",
        });
        dynamicHeaders.push({
          text: this.$t("_performance_ratio_"),
          value: "pr_clean",
        });
        dynamicHeaders.push({
          text: this.$t("_evolution_performance_ratio_"),
          value: "evolution_pr_clean",
        });
        dynamicHeaders.push({
          text: this.$t("_pertes_vs_modele_energie_"),
          value: "perf_score_parc",
        });
        dynamicHeaders.push({
          text: this.$t("_evolution__pertes_vs_modele_energie__"),
          value: "evolution_perf_score",
        });
        dynamicHeaders.push({
          text: this.$t("_disponibilite_"),
          value: "disponibilite",
        });
      }
      if (
        this.btnincident &&
        !dynamicHeaders.some((header) => header.text === "incident")
      ) {
        dynamicHeaders.push({
          text: this.$t("_criticite_"),
          value: "criticality_score",
        });
        dynamicHeaders.push({
          text: this.$t("_critiques_(ouverts)_"),
          value: "critic",
        });
        dynamicHeaders.push({
          text: this.$t("_severes_(ouverts)_"),
          value: "severe",
        });
        //dynamicHeaders.push({ text: this.$t('_actions_'), value: 'actions' });
      }
      if (
        this.btnconformite &&
        !dynamicHeaders.some((header) => header.text === "conformite")
      ) {
        dynamicHeaders.push({
          text: this.$t("_conformite_contractuelle_"),
          value: "conformite_contractuelle",
        });
        dynamicHeaders.push({
          text: this.$t("_conformite_pr_"),
          value: "conformite_pr",
        });
        dynamicHeaders.push({
          text: this.$t("_conformite_disponibilite_"),
          value: "conformite_disponibilite",
        });
      }
      return dynamicHeaders;
    },

    searchstartdate(id) {
      let start_date = "";

      this.installations.forEach((element) => {
        if (element.installation_id == id) {
          start_date = element.audit_start_date;
        }
      });
      return start_date;
    },

    searchenddate(id) {
      let end_date = "";

      this.installations.forEach((element) => {
        if (element.installation_id == id) {
          end_date = element.audit_end_date;
        }
      });
      return end_date;
    },

    takeselectsites() {
      let sites = [];
      this.installations.forEach((element) => {
        let cleanName = element.installation_name.trim();
        if (this.selectsite.includes(cleanName)) {
          sites.push(element);
        }
      });
      return sites;
    },

    goToInstallation(installation) {      
      let to = `/smart-guard/${installation.installation_id}?selected_date=${this.selected_date}`;
      this.$store.commit("SET_CUR_INSTALL_ID", installation.installation_id);
      this.$router.push(to);
    },
  },
};
</script>

<style scoped>
.custom-data-table {
  border-radius: 10px;
  overflow: hidden;
}

.custom-data-table .v-data-table-header {
  background-color: #e0e0e0;
}

.custom-data-table .v-data-table-header th {
  background-color: #e0e0e0;
}
</style>
